<template>

    <div class="hitotonari_detail-container" v-bind:class="{_block: display}">
        <div class="inner">

            <div class="item-wrap">

                <!-- IMG -->
                <div class="img-wrap">

                    <!-- MainImage -->
                    <div class="main md_no-image">
                        <div class="form_file-img">
                            <a class="md_icon-btn _hover delete" v-if="hitotonariData.image[1] !=='/img/no-image.svg'" @click="deleteImage(1)">
                                <div class="md_svg-icon"><SvgIconDelete /></div>
                            </a>
                            <input type="file" id="hitotonari-img1" accept="image/*" data-preview="_hitotonari-img1" v-on:change="changeImage($event, 1)">                 
                            <label for="hitotonari-img1" class="md_icon-btn _hover">
                                <div class="inner"><SvgIconImagePlace /></div>
                            </label>
                            <img class="preview _hitotonari-img1">
                            <img ref="hitotonariImage1" v-bind:src="hitotonariData.image[1]" alt="">
                        </div>
                    </div>

                    <!-- SubImage -->
                    <div class="sub-row">
                        <div class="sub md_no-image">
                            <div class="form_file-img">
                                <a class="md_icon-btn _hover delete" v-if="hitotonariData.image[2] !=='/img/no-image.svg'" @click="deleteImage(2)">
                                    <div class="md_svg-icon"><SvgIconDelete /></div>
                                </a>
                                <input type="file" id="hitotonari-img2" accept="image/*" data-preview="_hitotonari-img2" v-on:change="changeImage($event, 2)">
                                <label for="hitotonari-img2" class="md_icon-btn _hover">
                                    <div class="inner"><SvgIconImagePlace /></div>
                                </label>
                                <img class="preview _hitotonari-img2">
                                <img ref="hitotonariImage2" v-bind:src="hitotonariData.image[2]" alt="">
                            </div>
                        </div>
                        <div class="sub md_no-image">
                            <div class="form_file-img">
                                <a class="md_icon-btn _hover delete" v-if="hitotonariData.image[3] !=='/img/no-image.svg'" @click="deleteImage(3 )">
                                    <div class="md_svg-icon"><SvgIconDelete /></div>
                                </a>
                                <input type="file" id="hitotonari-img3" accept="image/*" data-preview="_hitotonari-img3" v-on:change="changeImage($event, 3)">
                                <label for="hitotonari-img3" class="md_icon-btn _hover">
                                    <div class="inner"><SvgIconImagePlace /></div>
                                </label>
                                <img class="preview _hitotonari-img3">
                                <img ref="hitotonariImage3" v-bind:src="hitotonariData.image[3]" alt="">
                            </div>
                        </div>
                    </div>

                </div><!-- /.IMG -->

                <!-- Detail -->
                <div class="detail-wrap">

                    <!-- Name -->
                    <div class="personal-info">
                        <h3 class="role form_text">
                            <input type="text" id="hitotonari-role" maxlength="250" placeholder=" " v-bind:value="hitotonariData.post" v-on:input="inputHitotonariItems($event, 'post')">
                            <label for="hitotonari-role" class="m-label"><span>役職名</span></label>
                        </h3>
                        <p class="name form_text">
                            <input type="text" id="hitotonari-name" maxlength="250" placeholder=" " v-bind:value="hitotonariData.name" v-on:input="inputHitotonariItems($event, 'name')">
                            <label for="hitotonari-name" class="m-label"><span>名前</span></label>
                        </p>
                    </div>

                    <!-- Text -->
                    <div class="text-wrap">
                        <h3 class="form_text">
                            <input type="text" id="hitotonari-title" maxlength="250" placeholder=" " v-bind:value="hitotonariData.title" v-on:input="inputHitotonariItems($event, 'title')">
                            <label for="hitotonari-title" class="m-label"><span>タイトル</span></label>
                        </h3>
                        <p class="form_text">
                            <textarea id="hitotonari-textarea1" maxlength="250" placeholder=" " data-dl-input-translation="true" v-bind:value="hitotonariData.description" v-on:input="inputHitotonariItems($event, 'description')"></textarea>
                            <label for="hitotonari-textarea1" class="m-label"><span>本文</span></label>
                        </p>
                    </div>

                    <!-- History -->
                    <div class="history-wrap">
                        <h3><span>History</span></h3>
                        <p class="form_text">
                            <textarea id="hitotonari-textarea2" maxlength="250" placeholder=" " data-dl-input-translation="true" v-bind:value="hitotonariData.history" v-on:input="inputHitotonariItems($event, 'history')"></textarea>
                            <label for="hitotonari-textarea2" class="m-label"><span>経歴など</span></label>
                        </p>
                    </div>

                </div><!-- /.Detail -->

            </div><!-- /.item-wrap -->

            <!-- SNS -->
            <div class="sns-edit">
                <div class="item form_text">
                    <input type="text" id="hitotonari-facebook" maxlength="250" placeholder=" " v-bind:value="hitotonariData.facebook" v-on:input="inputHitotonariItems($event, 'facebook')">
                    <label for="hitotonari-facebook" class="m-label"><span>Facebook Account</span></label>
                </div>
                <div class="item form_text">
                    <input type="text" id="hitotonari-twitter" maxlength="250" placeholder=" " v-bind:value="hitotonariData.twitter" v-on:input="inputHitotonariItems($event, 'twitter')">
                    <label for="hitotonari-twitter" class="m-label"><span>Twitter Account</span></label>
                </div>
                <div class="item form_text">
                    <input type="text" id="hitotonari-instagram" maxlength="250" placeholder=" " v-bind:value="hitotonariData.instagram" v-on:input="inputHitotonariItems($event, 'instagram')">
                    <label for="hitotonari-instagram" class="m-label"><span>Instagram Account</span></label>
                </div>
            </div>

            <!-- Recommend -->
            <div class="recommend">

                <!-- ITEM -->
                <div class="item" v-for="(data, key, index) in questionAndAnswers" v-bind:key="index">

                    <h3 class="form_text">質問</h3>
                
                    <div style="display: flex; width: 100%;">
                        <div class="item form_radio" style="width: 50%; padding: 0;" v-on:click="data.question_check = 0">
                            <input :id="'q-style' + index + 1" :name="'q-style' + index" type="radio" class="" v-bind:checked="data.question_check == 0" v-on:input="inputHitotonariQAndA($event, key, 'question_check')">
                            <label :for="'q-style' + index + 1">
                                <span>候補から選択</span>
                            </label>
                        </div>
                        <div class="item form_radio" style="width: 50%; padding: 0;" v-on:click="data.question_check = 1">
                            <input :id="'q-style2' + index + 1" :name="'q-style' + index" type="radio" class="" v-bind:checked="data.question_check == 1"  v-on:input="inputHitotonariQAndA($event, key, 'question_check')">
                            <label :for="'q-style2' + index + 1">
                                <span>自由入力</span>
                            </label>
                        </div>
                    </div>

                    <!-- 条件分岐 - 候補から選択の場合 -->
                    <div v-if="data.question_check == 0" class="form_select _hitotonari" style="margin-top: 1rem;">
                        <select name="" id="q-input-select" style="width: 100%; margin-top: 1rem;" v-bind:value="data.question_select_id" v-on:input="inputHitotonariQAndA($event, key, 'question_select_id')">
                            <option v-for="select_question in select_questions"
                                v-bind:value="select_question.id " 
                                v-bind:key="select_question.id">
                                {{ select_question.name }} 
                            </option>
                        </select>
                    </div>

                    <!-- 条件分岐 - 自由入力の場合 -->
                    <div v-if="data.question_check == 1" class="form_text" style="margin-top: 2rem;">
                        <input type="text" id="q-input-free" maxlength="250" placeholder=" " autocomplete="on"  v-bind:value="data.question" v-on:input="inputHitotonariQAndA($event, key, 'question')">
                        <label for="q-input-free" class="m-label"><span>質問</span></label>
                    </div>

                    <p class="form_text">
                        <textarea v-bind:id="'recommend-a' + key" maxlength="250" placeholder=" " data-dl-input-translation="true" v-bind:value="data.answer" v-on:input="inputHitotonariQAndA($event, key, 'answer')"></textarea>
                        <label v-bind:for="'recommend-a' + key" class="m-label"><span>回答</span></label>
                    </p>
                    <!-- Delete -->
                        {{ questionAndAnswers.length }}
                    <div class="md_add-del-wrap _w100">
                        <button type="button" class="dele" v-on:click="deleteQAndA(key)">
                            <div class="md_icon-btn">
                                <div class="inner">
                                    <SvgIconDelete />
                                </div>
                            </div>
                        </button>
                    </div>
                </div>

                <!-- ITEM -->
                <div class="item" v-if="qaNum < 3">
                    <button type="button" class="icon" v-on:click="addQAndA"></button>
                </div>
            </div><!-- /.Recommend -->

        </div>
    </div><!-- /.hitotonari_detail-container -->
    <ConfirmModalWithPromise ref="confirmModal" />
</template>

<script>
    import SvgIconSnsFacebook from '@/components/EndUser/svg/SvgIconSnsFacebook'
    import SvgIconSnsTwitter from '@/components/EndUser/svg/SvgIconSnsTwitter'
    import SvgIconSnsInstagram from '@/components/EndUser/svg/SvgIconSnsInstagram'
    import SvgIconImagePlace from '@/components/EndUser/svg/SvgIconImagePlace'
    import SvgIconDelete from '@/components/EndUser/svg/SvgIconDelete'
    import ConfirmModalWithPromise from '@/components/EndUser/ComponentList/ConfirmModalWithPromise'

    export default {
        components: {
            SvgIconSnsFacebook,
            SvgIconSnsTwitter,
            SvgIconSnsInstagram,
            SvgIconImagePlace,
            SvgIconDelete,
            "ConfirmModalWithPromise": ConfirmModalWithPromise
        },
        data() {
            return {
                imgSrc: '',
                question: '',
                select_questions: [
                    { id: 1, name: 'ご自身のマインドフルネスの方法を教えて下さい。' },
                    { id: 2, name: '趣味を教えて下さい。' },
                    { id: 3, name: '尊敬している人を教えて下さい。' },
                ]
            };
        },
        props: {
            hitotonariData: Object,
            display: Boolean,
        },
        methods: {
            changeImage(event, key) {
                const target = event.target;
                const dom = eval('this.$refs.hitotonariImage' + key);
                const rect = dom.getBoundingClientRect();
                const file = event.target.files[0];
                const type = file.type;
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.imgSrc = e.target.result;
                    const imgDatas = {
                        target: target,
                        src: this.imgSrc,
                        type: type,
                        domWidth: rect.width,
                        domHeight: rect.height,
                    }
                this.$emit("openCropper", imgDatas);
                }
                reader.readAsDataURL(file);
                document.getElementById('hitotonari-img' + key).value = '';
            },
            async deleteImage(key){
                const confirm = await this.$refs.confirmModal.show({ // 確認済み
                    title: '削除してもよろしいですか？',
                    message: '本当に削除してもよろしいですか？',
                    mode: "delete",
                    name: "confirmModalHitotonari"
                })
                if(confirm){
                    this.$emit("deleteImage", key, 'hitotonari');
                }
            },
            inputHitotonariItems(event, type) {
                // 仮に250文字以上になった場合lengthを250にする (文字制限)
                if(event.target.value.length > 250){
                    event.target.value = event.target.value.substring(0, 250);
                    return;
                }
                const item = {
                    value: event.target.value,
                    type: type,
                };
                this.$emit("inputHitotonariItems", item);
            },
            inputHitotonariQAndA(event, key, type) {
                // 仮に250文字以上になった場合lengthを250にする (文字制限)
                if(event.target.value.length > 250){
                    event.target.value = event.target.value.substring(0, 250);
                    return;
                }
                const item = {
                    value: event.target.value,
                    key: key,
                    type: type,
                };
                this.$emit("inputHitotonariQAndA", item);
            },
            deleteQAndA(key) {
                this.$emit("deleteQAndA", key);
            },
            addQAndA() {
                this.$emit("addQAndA");
            },
        },
        computed: {
            questionAndAnswers() {
                if (this.hitotonariData.questionAndAnswers) {
                    return this.hitotonariData.questionAndAnswers;
                }
            },
            qaNum() {
                if (this.hitotonariData.questionAndAnswers) {
                        return Object.keys(this.hitotonariData.questionAndAnswers).map(Number).length;
                }
            },
        },
    }
</script>